import { createHttpLink } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';

import { PRIVATE_GRAPHQL_URL } from '@itp/talent/constants/config';
import { Impersonate } from '@itp/talent/context/impersonateContext';


export const getAuthLink = (
  accessToken?: string,
  impersonate?: Impersonate | null,
  domain?: string,
  selectedCompany?: string,
) => {
  return setContext((_, { headers }) => {
    return {
      headers: {
        ...headers,
        ...(accessToken && { authorization: accessToken ? `Bearer ${accessToken}` : '' }),
        ...(impersonate?.externalId && {
          'x-impersonate-as': impersonate.externalId,
        }),
        ...(selectedCompany && { 'tp-company': selectedCompany }),
        ...(domain && { 'tp-domain': domain }),
      },
    };
  });
};

export const privateHttpLink = createHttpLink({
  uri: PRIVATE_GRAPHQL_URL,
});

export const generateDynamicHeaders = (pathname, user) => {
  const isCompany = pathname.startsWith('/company');

  return {
    domain: isCompany ? 'company' : 'talent',
    selectedCompany: user?.selectedCompanyId,
  };
};
